import {Box, Typography} from "@mui/material";
import React from "react";
import MediaIcon from "../../../../assets/icons/mediaIcon";
import FilesIcon from "../../../../assets/icons/filesIcon";
import ShareIcon from "../../../../assets/icons/shareIcon";
import {setAttachments} from "@store/chatSlice.tsx";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch} from "@store/store.tsx";

interface DrawerActionsProps {
    mediaInputRef: React.RefObject<HTMLInputElement>;
    fileInputRef: React.RefObject<HTMLInputElement>;
    handleShareAction: () => void;
    setIsDrawerOpen: any,
    setFileError:any,   
}
const MAX_FILES = 5;
const MAX_SIZE_MB = 25;

const DrawerActions: React.FC<DrawerActionsProps> = ({
                                                         mediaInputRef,
                                                         fileInputRef,
                                                         handleShareAction,
                                                         setIsDrawerOpen,
                                                         setFileError
                                                     }) => {
    const dispatch = useDispatch<AppDispatch>();
    const attachments = useSelector((state: any) => state.chat.attachments);
   
    const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        if(!files) return;

        const fileArray = Array.from(files);
        const newTotalFiles = attachments.length + fileArray.length;
        const totalSizeMB =
            [...attachments, ...fileArray].reduce((acc, file) => acc + file.size, 0) /
            (1024 * 1024);
        if (newTotalFiles > MAX_FILES) {
            setFileError(`You can only upload up to ${MAX_FILES} files.`);
            return;
        }
        if (totalSizeMB > MAX_SIZE_MB) {
            setFileError(`Total file size should not exceed ${MAX_SIZE_MB}MB.`);
            return;
        }
        setFileError(null);
        dispatch(setAttachments([...attachments, ...fileArray]));
        setIsDrawerOpen(false);
    }

    return (
        <>
            <Box className="flex flex-col items-center cursor-pointer" onClick={() => mediaInputRef.current?.click()}>
                <Typography>
                    <MediaIcon/>
                </Typography>
                <Typography
                    sx={{
                        marginTop: 1,
                        textTransform: "none",
                        color: "rgba(106, 108, 109, 1)",
                    }}
                >
                    Media
                </Typography>
                <input
                    ref={mediaInputRef}
                    hidden
                    type="file"
                    accept="image/*,video/*"
                    multiple
                    onChange={handleFileUpload}
                />
            </Box>

            <Box className="flex flex-col items-center cursor-pointer" onClick={() => fileInputRef.current?.click()}>
                <Typography>
                    <FilesIcon/>
                </Typography>
                <Typography
                    sx={{
                        marginTop: 1,
                        textTransform: "none",
                        color: "rgba(106, 108, 109, 1)",
                    }}
                >
                    Files
                </Typography>
                <input
                    ref={fileInputRef}
                    hidden
                    type="file"
                    multiple
                    onChange={handleFileUpload}
                />
            </Box>

            <Box
                className="flex flex-col items-center justify-end cursor-pointer"
                onClick={handleShareAction}
            >
                <Typography>
                    <ShareIcon style={{width: "38px", height: "38px"}}/>
                </Typography>
                <Typography
                    sx={{
                        marginTop: 1,
                        textTransform: "none",
                        color: "rgba(106, 108, 109, 1)",
                    }}
                >
                    Share
                </Typography>
            </Box>
        </>
    );
};

export default DrawerActions;
